module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAZUlEQVR4AWMYJMAj9D/DyuP/GVafJA0jgf8MBpb/GebvJt8AMJaQ+c8weS15BsAxD99/hsbp5BiAwMzMjP8nNKr9//XACR9GNwATb1tsgM8A6rsAEQbVEwYiFrSMSE4HlKfE4QEAaK9U4emyzgQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/BS.png
// module id = 1098
// module chunks = 0